module.exports = __webpack_public_path__ + "static/media/client-test-left.68ff2914.png";